import { Observable } from 'rxjs';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { Injectable, Directive, ContentChild, Component, Input, EventEmitter, Output, ViewChild, ViewEncapsulation, NgModule, ElementRef, defineInjectable } from '@angular/core';
import { MatInputModule } from '@angular/material/input'
import { MatCheckboxModule } from '@angular/material/checkbox';
import {MatRadioModule} from '@angular/material/radio';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatSelectModule} from '@angular/material/select';

import {MatMenuTrigger, MatMenuModule} from '@angular/material/menu';
import {MatTabsModule} from '@angular/material/tabs';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatChipsModule} from '@angular/material/chips';
import {MatTableModule, MatTableDataSource} from '@angular/material/table';

import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatDialogModule} from '@angular/material/dialog';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Partly compatible with MatTableDataSource, only includes filtering.
 * @template T
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@angular/material/menu';
import * as ɵngcc3 from '@angular/material/tabs';
import * as ɵngcc4 from '@angular/material/datepicker';
import * as ɵngcc5 from '@angular/material/checkbox';
import * as ɵngcc6 from '@angular/forms';
import * as ɵngcc7 from '@angular/material/input';
import * as ɵngcc8 from '@angular/material/radio';

const _c0 = ["filterMenu"];
function PwoFilterComponent_span_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function PwoFilterComponent_span_0_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 9);
    ɵngcc0.ɵɵlistener("click", function PwoFilterComponent_span_0_Template_span_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(); ctx_r10.visible = true; return ɵngcc0.ɵɵresetView(ctx_r10.open()); });
    ɵngcc0.ɵɵtemplate(1, PwoFilterComponent_span_0_ng_container_1_Template, 1, 0, "ng-container", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r3 = ɵngcc0.ɵɵreference(4);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r3);
} }
function PwoFilterComponent_span_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function PwoFilterComponent_span_1_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 11);
    ɵngcc0.ɵɵlistener("click", function PwoFilterComponent_span_1_Template_span_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r13.visible = true); });
    ɵngcc0.ɵɵtemplate(1, PwoFilterComponent_span_1_ng_container_1_Template, 1, 0, "ng-container", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r5 = ɵngcc0.ɵɵreference(6);
    const _r3 = ɵngcc0.ɵɵreference(4);
    ɵngcc0.ɵɵproperty("matMenuTriggerFor", _r5);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r3);
} }
function PwoFilterComponent_button_2_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function PwoFilterComponent_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 12);
    ɵngcc0.ɵɵlistener("menuOpened", function PwoFilterComponent_button_2_Template_button_menuOpened_0_listener() { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r16 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r16.visible = true); });
    ɵngcc0.ɵɵprojection(1);
    ɵngcc0.ɵɵelement(2, "div", 13);
    ɵngcc0.ɵɵtemplate(3, PwoFilterComponent_button_2_ng_container_3_Template, 1, 0, "ng-container", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    const _r5 = ɵngcc0.ɵɵreference(6);
    const _r3 = ɵngcc0.ɵɵreference(4);
    ɵngcc0.ɵɵclassProp("active", ctx_r2.visible);
    ɵngcc0.ɵɵproperty("matMenuTriggerFor", _r5);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r3);
} }
function PwoFilterComponent_ng_template_3_ng_container_0_i_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "i", 17);
    ɵngcc0.ɵɵtext(1, "keyboard_arrow_down");
    ɵngcc0.ɵɵelementEnd();
} }
function PwoFilterComponent_ng_template_3_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "span", null, 15);
    ɵngcc0.ɵɵprojection(3, 1);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, PwoFilterComponent_ng_template_3_ng_container_0_i_4_Template, 2, 0, "i", 16);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r21 = ɵngcc0.ɵɵreference(2);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", _r21.childNodes.length === 0);
} }
function PwoFilterComponent_ng_template_3_ng_container_1_i_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "i", 17);
    ɵngcc0.ɵɵtext(1, "keyboard_arrow_up");
    ɵngcc0.ɵɵelementEnd();
} }
function PwoFilterComponent_ng_template_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "span", null, 18);
    ɵngcc0.ɵɵprojection(3, 2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, PwoFilterComponent_ng_template_3_ng_container_1_i_4_Template, 2, 0, "i", 16);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r23 = ɵngcc0.ɵɵreference(2);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", _r23.childNodes.length === 0);
} }
function PwoFilterComponent_ng_template_3_ng_container_2_i_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "i", 17);
    ɵngcc0.ɵɵtext(1, "filter_list");
    ɵngcc0.ɵɵelementEnd();
} }
function PwoFilterComponent_ng_template_3_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "span", null, 19);
    ɵngcc0.ɵɵprojection(3, 3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, PwoFilterComponent_ng_template_3_ng_container_2_i_4_Template, 2, 0, "i", 16);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r25 = ɵngcc0.ɵɵreference(2);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", _r25.childNodes.length === 0);
} }
function PwoFilterComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, PwoFilterComponent_ng_template_3_ng_container_0_Template, 5, 1, "ng-container", 14);
    ɵngcc0.ɵɵtemplate(1, PwoFilterComponent_ng_template_3_ng_container_1_Template, 5, 1, "ng-container", 14);
    ɵngcc0.ɵɵtemplate(2, PwoFilterComponent_ng_template_3_ng_container_2_Template, 5, 1, "ng-container", 14);
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r4.visible && !ctx_r4.filter.isApplied);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.visible && !ctx_r4.filter.isApplied);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.filter.isApplied);
} }
function PwoFilterComponent_lib_date_filter_8_Template(rf, ctx) { if (rf & 1) {
    const _r28 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "lib-date-filter", 20);
    ɵngcc0.ɵɵlistener("close", function PwoFilterComponent_lib_date_filter_8_Template_lib_date_filter_close_0_listener() { ɵngcc0.ɵɵrestoreView(_r28); const ctx_r27 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r27.close()); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("filter", ctx_r6.filter)("filterService", ctx_r6.filterService)("visible", ctx_r6.visible);
} }
function PwoFilterComponent_lib_single_select_filter_9_Template(rf, ctx) { if (rf & 1) {
    const _r30 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "lib-single-select-filter", 21);
    ɵngcc0.ɵɵlistener("close", function PwoFilterComponent_lib_single_select_filter_9_Template_lib_single_select_filter_close_0_listener() { ɵngcc0.ɵɵrestoreView(_r30); const ctx_r29 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r29.close()); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("filter", ctx_r7.filter)("filterService", ctx_r7.filterService);
} }
function PwoFilterComponent_lib_multi_select_filter_10_Template(rf, ctx) { if (rf & 1) {
    const _r32 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "lib-multi-select-filter", 21);
    ɵngcc0.ɵɵlistener("close", function PwoFilterComponent_lib_multi_select_filter_10_Template_lib_multi_select_filter_close_0_listener() { ɵngcc0.ɵɵrestoreView(_r32); const ctx_r31 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r31.close()); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("filter", ctx_r8.filter)("filterService", ctx_r8.filterService);
} }
const _c1 = ["*", [["", "icon-closed", ""]], [["", "icon-opened", ""]], [["", "icon-applied", ""]]];
const _c2 = ["*", "[icon-closed]", "[icon-opened]", "[icon-applied]"];
const _c3 = ["tabGroup"];
function MultiSelectFilterComponent_mat_checkbox_9_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "mat-checkbox", 6);
    ɵngcc0.ɵɵlistener("change", function MultiSelectFilterComponent_mat_checkbox_9_Template_mat_checkbox_change_0_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r2.change()); })("ngModelChange", function MultiSelectFilterComponent_mat_checkbox_9_Template_mat_checkbox_ngModelChange_0_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r3); const f_r1 = restoredCtx.$implicit; return ɵngcc0.ɵɵresetView(f_r1.selected = $event); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const f_r1 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngModel", f_r1.selected);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", f_r1.title, " ");
} }
function SingleSelectFilterComponent_div_6_mat_radio_button_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-radio-button", 12);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const f_r3 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("value", f_r3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", f_r3.title, " ");
} }
function SingleSelectFilterComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 9)(1, "mat-radio-group", 10);
    ɵngcc0.ɵɵlistener("ngModelChange", function SingleSelectFilterComponent_div_6_Template_mat_radio_group_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r4.selected = $event); });
    ɵngcc0.ɵɵtemplate(2, SingleSelectFilterComponent_div_6_mat_radio_button_2_Template, 2, 2, "mat-radio-button", 11);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.selected);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.filterValues);
} }
function SingleSelectFilterComponent_button_13_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 7);
    ɵngcc0.ɵɵlistener("click", function SingleSelectFilterComponent_button_13_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r6.clear()); });
    ɵngcc0.ɵɵelementStart(1, "i", 4);
    ɵngcc0.ɵɵtext(2, "clear");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "span");
    ɵngcc0.ɵɵtext(4, "Clear");
    ɵngcc0.ɵɵelementEnd()();
} }
class FilterDataSource {
    /**
     * @param {?=} data
     */
    constructor(data) {
        this.data = [];
        this.changes = new Observable(observer => {
            observer.next('trigger');
            this.changesSub = observer;
        });
        /**
         * Copied from MatDataTableSource!
         *
         * Checks if a data object matches the data source's filter string. By default, each data object
         * is converted to a string of its properties and returns true if the filter has
         * at least one occurrence in that string. By default, the filter string has its whitespace
         * trimmed and the match is case-insensitive. May be overridden for a custom implementation of
         * filter matching.
         * @param data Data object used to check against the filter.
         * @param filter Filter string that has been set on the data source.
         * @return Whether the filter matches against the data
         */
        this.filterPredicate = (data, filter) => {
            // Transform the data into a lowercase string of all property values.
            /** @type {?} */
            const dataStr = Object.keys(data).reduce((currentTerm, key) => {
                // Use an obscure Unicode character to delimit the words in the concatenated string.
                // This avoids matches where the values of two columns combined will match the user's query
                // (e.g. `Flute` and `Stop` will match `Test`). The character is intended to be something
                // that has a very low chance of being typed in by somebody in a text field. This one in
                // particular is "White up-pointing triangle with dot" from
                // https://en.wikipedia.org/wiki/List_of_Unicode_characters
                return currentTerm + ((/** @type {?} */ (data)))[key] + '◬';
            }, '').toLowerCase();
            // Transform the filter by converting it to lowercase and removing whitespace.
            /** @type {?} */
            const transformedFilter = filter.trim().toLowerCase();
            return dataStr.indexOf(transformedFilter) !== -1;
        };
        this.data = data || [];
        this.triggerFilter();
    }
    /**
     * @return {?}
     */
    get filter() {
        return this._filter;
    }
    /**
     * @param {?} filter
     * @return {?}
     */
    set filter(filter) {
        this._filter = filter;
        this.triggerFilter();
    }
    /**
     * @private
     * @return {?}
     */
    triggerFilter() {
        this.filteredData = this._filterData(this.data);
        if (this.changesSub) {
            this.changesSub.next('trigger');
        }
    }
    /**
     * Refactored from MatDataTableSource!
     *
     * Returns a filtered data array where each filter object contains the filter string within
     * the result of the filterTermAccessor function. If no filter is set, returns the data array
     * as provided.
     * @param {?} data
     * @return {?}
     */
    _filterData(data) {
        // If there is a filter string, filter out data that does not contain it.
        // Each data object is converted to a string using the function defined by filterTermAccessor.
        // May be overridden for customization.
        this.filteredData = !this.filter ? data : data.filter(obj => this.filterPredicate(obj, this.filter));
        return this.filteredData;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Generic filter, can't be used to filter a column!
 * @abstract
 */
class Filter {
    /**
     * @param {?} key
     * @param {?=} valueAccessor
     */
    constructor(key, valueAccessor) {
        this.isApplied = false;
        this.valueAccessor = (_) => {
            _ = _[this.key];
            if (typeof _ === 'object' && _ !== null) {
                if (Array.isArray(_.results)) {
                    return _.results.map(item => item.Title || item);
                }
                if (_.Title !== undefined && _.Title !== null) {
                    return _.Title;
                }
            }
            return _;
        };
        this.key = key;
        if (valueAccessor) {
            this.valueAccessor = valueAccessor;
        }
    }
}
/**
 * A Filter must implement this, so that filter values of the filter can be generated.
 * @record
 */
function FilterValueGenerator() { }
/**
 * @param {?} arg
 * @return {?}
 */
function isFilterValueGenerator(arg) {
    return ((/** @type {?} */ (arg))).getFilterValues !== undefined;
}
/**
 * Use this filter to filter for a specific value in a column.
 * @template T
 */
class ValueFilter extends Filter {
    /**
     * @return {?}
     */
    isActive() {
        return this.value !== undefined && this.value !== null;
    }
    /**
     * @param {?} item
     * @return {?}
     */
    matches(item) {
        // return !this.isActive() || item[this.key] === this.value;
        if (!this.isActive()) {
            return true;
        }
        /** @type {?} */
        const value = this.valueAccessor(item);
        if (Array.isArray(value)) {
            return value.includes(this.value);
        }
        return value === this.value;
    }
    /**
     * @param {?} data
     * @return {?}
     */
    getFilterValues(data) {
        /** @type {?} */
        let values = data.map(el => this.valueAccessor(el)).filter(el => el !== undefined && el !== null);
        // Remove duplicates
        values = values.sort().filter((item, pos, arr) => {
            return !pos || item !== arr[pos - 1];
        });
        return values.map(el => ({ title: el, selected: el === this.value }));
    }
}
/**
 * Use this filter to filter for multiple possible values in a column.
 * @template T
 */
class MultiValueFilter extends Filter {
    constructor() {
        super(...arguments);
        /**
         * Set this to true to set the filter even if the selected array is empty.
         */
        this.forceFilter = false;
        /**
         * Set this to true to only match items whose property is a subset of the selected array.
         */
        this.matchAll = false;
    }
    /**
     * @return {?}
     */
    isActive() {
        return this.selected && (this.forceFilter || this.selected.length > 0);
    }
    /**
     * @param {?} item
     * @return {?}
     */
    matches(item) {
        if (!this.isActive()) {
            return true;
        }
        /** @type {?} */
        const value = this.valueAccessor(item);
        if (Array.isArray(value)) {
            if (this.matchAll) {
                for (const val of value) {
                    if (!this.selected.includes(val)) {
                        return false;
                    }
                }
                return true;
            }
            else {
                return haveEqualItem(this.selected, value);
            }
        }
        return this.selected.includes(value);
    }
    /**
     * @param {?} data
     * @return {?}
     */
    getFilterValues(data) {
        /** @type {?} */
        let allValues = [];
        data.forEach(el => {
            /** @type {?} */
            const vals = this.valueAccessor(el);
            if (Array.isArray(vals)) {
                vals.forEach(val => {
                    if (!allValues.includes(val)) {
                        allValues.push(val);
                    }
                });
            }
            else {
                if (!allValues.includes(vals)) {
                    allValues.push(vals);
                }
            }
        });
        allValues = allValues.filter(el => el !== undefined && el !== null);
        allValues.sort();
        /** @type {?} */
        const sel = this.selected;
        return allValues.map(el => ({ title: el, selected: sel ? sel.includes(el) : undefined }));
    }
}
/**
 * Use this filter to filter numbers that are in the specified range.
 */
class RangeFilter extends Filter {
    /**
     * @return {?}
     */
    isActive() {
        return (this.min !== undefined && this.min !== null) || (this.max !== undefined && this.max !== null);
    }
    /**
     * @param {?} item
     * @return {?}
     */
    matches(item) {
        /** @type {?} */
        const value = this.valueAccessor(item);
        if (typeof value !== 'number') {
            throw new Error(`RangeFilter can only process numbers, but got a ${typeof value} (${value})!`);
        }
        if (this.min && value < this.min) {
            return false;
        }
        if (this.max && value > this.max) {
            return false;
        }
        return true;
    }
}
/**
 * Use this filter to filter dates. You can specify a start date, an end date or both.
 */
class DateFilter extends Filter {
    /**
     * @return {?}
     */
    isActive() {
        return (this.start !== undefined && this.start !== null) || (this.end !== undefined && this.end !== null);
    }
    /**
     * @param {?} item
     * @return {?}
     */
    matches(item) {
        if (!this.isActive()) {
            return true;
        }
        /** @type {?} */
        const start = new Date(this.start).getTime();
        // returns NaN if date is invalid
        /** @type {?} */
        const end = new Date(this.end).getTime();
        /** @type {?} */
        const date = new Date(this.valueAccessor(item));
        if (isNaN(date) || !(date instanceof Date)) {
            throw new Error(`DateFilter can only process Date objects or ISO date strings!`);
        }
        /** @type {?} */
        const time = date.getTime();
        if (time < start || time > end) {
            return false;
        }
        return true;
    }
}
/**
 * @param {?} arr1
 * @param {?} arr2
 * @return {?}
 */
function haveEqualItem(arr1, arr2) {
    /** @type {?} */
    let out = false;
    arr1.forEach(el => {
        if (arr2.includes(el)) {
            out = true;
        }
    });
    return out;
}

var F = /*#__PURE__*/Object.freeze({
    Filter: Filter,
    FilterValueGenerator: FilterValueGenerator,
    isFilterValueGenerator: isFilterValueGenerator,
    ValueFilter: ValueFilter,
    MultiValueFilter: MultiValueFilter,
    RangeFilter: RangeFilter,
    DateFilter: DateFilter
});

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PwoFilterService {
    constructor() {
        this.filterValuesSubs = [];
        this._search = '';
        /**
         * Set this to false to not go back to the first page when a filter is applied.
         * If you do this, keep in mind that if you are on a page that doesn't exist
         * anymore after a filter is applied, you hvae to go back manually!
         */
        this.enablePaginatorReset = true;
        /**
         * Set this to false to stop cascade filter values.
         */
        this.enableCascadingFilterValues = true;
        /**
         * EXPERIMENTAL FEATURE!
         *
         * Set this to false to show all items that match at least one of the applied filters.
         * At default, only items that match all applied filters are shown.
         */
        this.matchAllFilters = true;
        this.resetAll();
    }
    /**
     * @return {?}
     */
    get search() {
        return this._search;
    }
    /**
     * @param {?} search
     * @return {?}
     */
    set search(search) {
        this._search = search;
        this.triggerFilter();
    }
    /**
     * Call this in onDestroy of the component with the table to make
     * the service ready if it is used in a different table component.
     * @return {?}
     */
    resetAll() {
        this.recordFilter = {};
        this.filterValuesSubs = [];
        this.dataSource = undefined;
    }
    /**
     * @param {?} data
     * @return {?}
     */
    setDataSource(data) {
        this.dataSource = data;
        this.checkIfReady();
        this.distributeFilterValues();
        this.dataSource.filterPredicate = el => this.filterPredicate(el); // normally, second parameter is filter string, omit it!
    }
    /**
     * @param {?} filter
     * @return {?}
     */
    applyFilter(filter) {
        console.log('apply', filter);
        this.checkIfReady();
        if (filter.isActive()) {
            // Set filter
            filter.isApplied = true;
            this.recordFilter[filter.key] = filter;
        }
        else {
            // Delete filter
            filter.isApplied = false;
            delete this.recordFilter[filter.key];
        }
        this.setFilterActiveClass(filter);
        this.triggerFilter();
    }
    /**
     * @param {?} filter
     * @return {?}
     */
    filterValuesObservable(filter) {
        // console.log('subscribing', filter);
        // console.log('subscribing', filter);
        /** @type {?} */
        const obs = new Observable(observer => {
            // console.log('subscribed to ' + filter.key);
            this.filterValuesSubs.push({ filter, observer });
            if (this.dataSource) {
                /** @type {?} */
                const vals = this.generateFilterValuesFor(filter, this.dataSource.data);
                observer.next(vals);
            }
        });
        return obs;
    }
    /**
     * @param {?} filter
     * @return {?}
     */
    setFilterActiveClass(filter) {
        /** @type {?} */
        const el = document.querySelector('.mat-column-' + filter.key);
        if (el) {
            if (filter.isActive()) {
                el.classList.add('pwo-filter-active');
            }
            else {
                el.classList.remove('pwo-filter-active');
            }
        }
    }
    /**
     * @param {?} filter
     * @return {?}
     */
    isSet(filter) {
        return this.recordFilter[filter.key] ? true : false;
    }
    /**
     * @return {?}
     */
    hasFilterSet() {
        return Object.values(this.recordFilter).length > 0;
    }
    /**
     * @return {?}
     */
    clearAllFilters() {
        Object.values(this.recordFilter).forEach((filter) => filter.isApplied = false);
        this.recordFilter = {};
        // this.dataSource.filter = '';
        this.triggerFilter();
        // Remove all filter active classes
        /** @type {?} */
        const cols = document.querySelectorAll('.pwo-filter-active');
        cols.forEach(col => col.classList.remove('pwo-filter-active'));
    }
    /**
     * @private
     * @return {?}
     */
    triggerFilter() {
        if (this.enablePaginatorReset && this.dataSource instanceof MatTableDataSource && this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
        this.dataSource.filter = 'trigger filter';
        if (this.enableCascadingFilterValues) {
            this.distributeFilterValues(true);
        }
    }
    /**
     * @private
     * @param {?} el
     * @param {?=} recordFilter
     * @return {?}
     */
    filterPredicate(el, recordFilter = this.recordFilter) {
        /** @type {?} */
        const appliedFilters = Object.values(recordFilter);
        if (appliedFilters.length === 0 && this.search.length === 0) {
            // No filtering
            return true;
        }
        /** @type {?} */
        let isVisible = this.matchAllFilters;
        // Default text search:
        if (this.search.length > 0) {
            /** @type {?} */
            const search = new FilterDataSource([]).filterPredicate;
            isVisible = search(el, this.search);
        }
        appliedFilters.forEach(filter => {
            if (this.matchAllFilters) {
                if (!filter.matches(el)) {
                    isVisible = false;
                }
            }
            else {
                if (filter.matches(el)) {
                    isVisible = true;
                }
            }
        });
        return isVisible;
    }
    /**
     * @private
     * @param {?} recordFilter
     * @return {?}
     */
    getFilteredData(recordFilter) {
        return this.dataSource.data.filter(el => this.filterPredicate(el, recordFilter));
    }
    /**
     * @private
     * @param {?=} cascading
     * @return {?}
     */
    distributeFilterValues(cascading = false) {
        this.filterValuesSubs.forEach(sub => {
            if (isFilterValueGenerator(sub.filter)) {
                if (!cascading || sub.filter.isCascading !== false) {
                    /** @type {?} */
                    const recordFilterWithoutThisFilter = {};
                    Object.keys(this.recordFilter).forEach(key => {
                        if (key !== sub.filter.key) {
                            recordFilterWithoutThisFilter[key] = this.recordFilter[key];
                        }
                    });
                    /** @type {?} */
                    const dataIfAllButThisFilterAreSet = this.getFilteredData(recordFilterWithoutThisFilter);
                    /** @type {?} */
                    const filterValues = this.generateFilterValuesFor(sub.filter, dataIfAllButThisFilterAreSet);
                    sub.observer.next(filterValues);
                }
            }
            else {
                throw new Error(`Filter on property ${sub.filter.key} doesn't implement FilterValueGenerator, so filter values cannot be generated.`);
            }
        });
    }
    /**
     * @private
     * @param {?} filter
     * @param {?} data
     * @return {?}
     */
    generateFilterValuesFor(filter, data) {
        if (isFilterValueGenerator(filter)) {
            /** @type {?} */
            const vals = filter.getFilterValues(data);
            vals.forEach(val => {
                if (val.selected === undefined) {
                    val.selected = this.matchAllFilters;
                }
            });
            return vals;
        }
        else {
            throw new Error(`Filter on property ${filter.key} doesn't implement FilterValueGenerator, so filter values cannot be generated.`);
        }
    }
    // private buildFilterValue(val: string, filter: FilterConf) {
    //   const recFilter = this.recordFilter[filter.key];
    //   let selected = true;
    //   if (recFilter) {
    //     if (!(recFilter instanceof MultiValueFilter)) {
    //       throw new Error(filter.key + ' has to be a MultiSelectFilter<any>, not a DateFilter!');
    //     }
    //     if (recFilter.selected.findIndex(el => el.title === val) === -1) {
    //       selected = false;
    //     }
    //   }
    //   return {
    //     title: val,
    //     name: val,
    //     selected,
    //   };
    // }
    // private getSingleValue(el, filter: FilterConf): string {
    //   switch (filter.type) {
    //     case FilterType.String:
    //     case FilterType.Number:
    //       return el[filter.key];
    //     case FilterType.Lookup:
    //       return el[filter.key][filter.lookupField || 'Title'];
    //   }
    // }
    // private getMultipleValues(el, filter: FilterConf): Array<string> {
    //   switch (filter.type) {
    //     case FilterType.Array:
    //       return el[filter.key];
    //     case FilterType.MultiLookup:
    //       return el[filter.key].results.map(item => item[filter.lookupField || 'Title']);
    //   }
    // }
    /**
     * @private
     * @return {?}
     */
    checkIfReady() {
        if (!this.dataSource) {
            throw new Error('Set a data source with setDataSource(dataSource: MatTableDataSource<any> | FilterDataSource<any>) first!');
        }
    }
}
PwoFilterService.ɵfac = function PwoFilterService_Factory(t) { return new (t || PwoFilterService)(); };
PwoFilterService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: PwoFilterService, factory: PwoFilterService.ɵfac, providedIn: 'root' });
/** @nocollapse */
PwoFilterService.ctorParameters = () => [];
/** @nocollapse */ PwoFilterService.ngInjectableDef = defineInjectable({ factory: function PwoFilterService_Factory() { return new PwoFilterService(); }, token: PwoFilterService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PwoFilterService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PwoFilterComponent {
    /**
     * @param {?} element
     */
    constructor(element) {
        this.toggle = new EventEmitter();
        this.visible = false;
        this.filterTypes = F;
        this.isDisabled = false;
        this.isAnchored = false;
        this.hasStyles = false;
        // Detect if used as a header filter in MatTable
        /** @type {?} */
        const p = element.nativeElement.parentElement;
        this.isHeaderFilter = p && (p.tagName === 'MAT-HEADER-CELL' || p.attributes.getNamedItem('mat-header-cell'));
        this.hasStyles = element.nativeElement.hasAttribute('pwo');
    }
    /**
     * @return {?}
     */
    get xPosition() {
        return this.align === 'right' ? 'before' : 'after';
    }
    /**
     * @param {?} filter
     * @param {?} filterType
     * @return {?}
     */
    is(filter, filterType) {
        return filter instanceof filterType;
    }
    /**
     * @return {?}
     */
    open() {
        this.toggle.next(true);
    }
    /**
     * @return {?}
     */
    close() {
        if (this.isAnchored) {
            this.toggle.next(false);
        }
        if (this.triggerMenu) {
            this.triggerMenu.closeMenu();
        }
    }
}
PwoFilterComponent.ɵfac = function PwoFilterComponent_Factory(t) { return new (t || PwoFilterComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
PwoFilterComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: PwoFilterComponent, selectors: [["pwo-filter"], ["", "pwoFilter", ""]], viewQuery: function PwoFilterComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(MatMenuTrigger, 5);
        ɵngcc0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.triggerMenu = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.menuRef = _t.first);
    } }, inputs: { align: "align", filter: "filter", filterService: "filterService" }, outputs: { toggle: "toggle" }, ngContentSelectors: _c2, decls: 11, vars: 9, consts: [["class", "pointer", 3, "click", 4, "ngIf"], ["class", "pointer", 3, "matMenuTriggerFor", "click", 4, "ngIf"], ["mat-button", "", 3, "matMenuTriggerFor", "active", "menuOpened", 4, "ngIf"], ["filterIcon", ""], [3, "xPosition", "closed"], ["filterMenu", "matMenu"], [1, "pwo-filter", 3, "click"], [3, "filter", "filterService", "visible", "close", 4, "ngIf"], [3, "filter", "filterService", "close", 4, "ngIf"], [1, "pointer", 3, "click"], [4, "ngTemplateOutlet"], [1, "pointer", 3, "matMenuTriggerFor", "click"], ["mat-button", "", 3, "matMenuTriggerFor", "menuOpened"], [1, "spacer"], [4, "ngIf"], ["iconClosed", ""], ["class", "material-icons", 4, "ngIf"], [1, "material-icons"], ["iconOpened", ""], ["iconApplied", ""], [3, "filter", "filterService", "visible", "close"], [3, "filter", "filterService", "close"]], template: function PwoFilterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c1);
        ɵngcc0.ɵɵtemplate(0, PwoFilterComponent_span_0_Template, 2, 1, "span", 0);
        ɵngcc0.ɵɵtemplate(1, PwoFilterComponent_span_1_Template, 2, 2, "span", 1);
        ɵngcc0.ɵɵtemplate(2, PwoFilterComponent_button_2_Template, 4, 4, "button", 2);
        ɵngcc0.ɵɵtemplate(3, PwoFilterComponent_ng_template_3_Template, 3, 3, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementStart(5, "mat-menu", 4, 5);
        ɵngcc0.ɵɵlistener("closed", function PwoFilterComponent_Template_mat_menu_closed_5_listener() { return ctx.visible = false; });
        ɵngcc0.ɵɵelementStart(7, "div", 6);
        ɵngcc0.ɵɵlistener("click", function PwoFilterComponent_Template_div_click_7_listener($event) { return $event.stopPropagation(); });
        ɵngcc0.ɵɵtemplate(8, PwoFilterComponent_lib_date_filter_8_Template, 1, 3, "lib-date-filter", 7);
        ɵngcc0.ɵɵtemplate(9, PwoFilterComponent_lib_single_select_filter_9_Template, 1, 2, "lib-single-select-filter", 8);
        ɵngcc0.ɵɵtemplate(10, PwoFilterComponent_lib_multi_select_filter_10_Template, 1, 2, "lib-multi-select-filter", 8);
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.isAnchored);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isAnchored && ctx.isHeaderFilter);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isAnchored && !ctx.isHeaderFilter);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("xPosition", ctx.xPosition);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassProp("pwo-styles", ctx.hasStyles);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.is(ctx.filter, ctx.filterTypes.DateFilter));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.is(ctx.filter, ctx.filterTypes.ValueFilter));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.is(ctx.filter, ctx.filterTypes.MultiValueFilter));
    } }, dependencies: function () { return [ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet, ɵngcc2.MatMenu, ɵngcc2.MatMenuTrigger, DateFilterComponent, MultiSelectFilterComponent, SingleSelectFilterComponent]; }, styles: [".pwo-filter[_ngcontent-%COMP%]{padding:8px}.pointer[_ngcontent-%COMP%]{cursor:pointer}button[_ngcontent-%COMP%]{display:flex;align-items:center}button[_ngcontent-%COMP%]   .spacer[_ngcontent-%COMP%]{display:none}.material-icons[_ngcontent-%COMP%]{margin-left:4px}  pwo-filter[pwo]{display:flex}  pwo-filter[pwo] button{width:100%;border:2px solid #2387aa;padding:6px 10px}  pwo-filter[pwo] button.active,   pwo-filter[pwo] button:hover{background-color:#2387aa;color:#fff}  pwo-filter[pwo] button>.spacer{flex:1;display:block!important}"] });
/** @nocollapse */
PwoFilterComponent.ctorParameters = () => [
    { type: ElementRef }
];
PwoFilterComponent.propDecorators = {
    triggerMenu: [{ type: ViewChild, args: [MatMenuTrigger,] }],
    align: [{ type: Input }],
    filter: [{ type: Input }],
    filterService: [{ type: Input }],
    toggle: [{ type: Output }],
    menuRef: [{ type: ViewChild, args: ['filterMenu',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PwoFilterComponent, [{
        type: Component,
        args: [{ selector: 'pwo-filter, [pwoFilter]', template: "<!-- FILTER ELEMENT -->\r\n<span class=\"pointer\" *ngIf=\"isAnchored\" (click)=\"visible = true; open()\">\r\n    <ng-container *ngTemplateOutlet=\"filterIcon\"></ng-container>\r\n</span>\r\n<span class=\"pointer\" *ngIf=\"!isAnchored && isHeaderFilter\" (click)=\"visible = true\"  [matMenuTriggerFor]=\"filterMenu\">\r\n    <ng-container *ngTemplateOutlet=\"filterIcon\"></ng-container>        \r\n</span>\r\n<button mat-button [matMenuTriggerFor]=\"filterMenu\" [class.active]=\"visible\" (menuOpened)=\"visible = true\" *ngIf=\"!isAnchored && !isHeaderFilter\">\r\n    <ng-content></ng-content>\r\n    <div class=\"spacer\"></div>\r\n    <ng-container *ngTemplateOutlet=\"filterIcon\"></ng-container>\r\n</button>\r\n\r\n<!-- FILTER ICON -->\r\n<ng-template #filterIcon>\r\n    <ng-container *ngIf=\"!visible && !filter.isApplied\">\r\n        <span #iconClosed>\r\n            <ng-content select=\"[icon-closed]\"></ng-content>\r\n        </span>\r\n        <i *ngIf=\"iconClosed.childNodes.length === 0\" class=\"material-icons\">keyboard_arrow_down</i>\r\n    </ng-container>\r\n\r\n    <ng-container *ngIf=\"visible && !filter.isApplied\">\r\n        <span #iconOpened>\r\n            <ng-content select=\"[icon-opened]\"></ng-content>\r\n        </span>\r\n        <i *ngIf=\"iconOpened.childNodes.length === 0\" class=\"material-icons\">keyboard_arrow_up</i>\r\n    </ng-container>\r\n\r\n    <ng-container *ngIf=\"filter.isApplied\">\r\n        <span #iconApplied>\r\n            <ng-content select=\"[icon-applied]\"></ng-content>\r\n        </span>\r\n        <!-- <i *ngIf=\"iconApplied.childNodes.length === 0\" class=\"icon--filter\"></i> -->\r\n        <i *ngIf=\"iconApplied.childNodes.length === 0\" class=\"material-icons\">filter_list</i>\r\n    </ng-container>\r\n</ng-template>\r\n\r\n<!-- FILTER COMPONENT -->\r\n<mat-menu #filterMenu=\"matMenu\" [xPosition]=\"xPosition\" (closed)=\"visible = false\">\r\n    <div class=\"pwo-filter\" [class.pwo-styles]=\"hasStyles\" (click)=\"$event.stopPropagation();\">\r\n        <lib-date-filter *ngIf=\"is(filter, filterTypes.DateFilter)\" [filter]=\"filter\" [filterService]=\"filterService\" (close)=\"close()\" [visible]=\"visible\">\r\n        </lib-date-filter>\r\n\r\n        <lib-single-select-filter *ngIf=\"is(filter, filterTypes.ValueFilter)\" [filter]=\"filter\" [filterService]=\"filterService\" (close)=\"close()\">\r\n        </lib-single-select-filter>\r\n\r\n        <lib-multi-select-filter *ngIf=\"is(filter, filterTypes.MultiValueFilter)\" [filter]=\"filter\" [filterService]=\"filterService\" (close)=\"close()\">\r\n        </lib-multi-select-filter>\r\n    </div>\r\n</mat-menu>", styles: [".pwo-filter{padding:8px}.pointer{cursor:pointer}button{display:flex;align-items:center}button .spacer{display:none}.material-icons{margin-left:4px}::ng-deep pwo-filter[pwo]{display:flex}::ng-deep pwo-filter[pwo] button{width:100%;border:2px solid #2387aa;padding:6px 10px}::ng-deep pwo-filter[pwo] button.active,::ng-deep pwo-filter[pwo] button:hover{background-color:#2387aa;color:#fff}::ng-deep pwo-filter[pwo] button>.spacer{flex:1;display:block!important}"] }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { toggle: [{
            type: Output
        }], triggerMenu: [{
            type: ViewChild,
            args: [MatMenuTrigger]
        }], align: [{
            type: Input
        }], filter: [{
            type: Input
        }], filterService: [{
            type: Input
        }], menuRef: [{
            type: ViewChild,
            args: ['filterMenu']
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DateFilterComponent {
    /**
     * @param {?} defaultFilterService
     */
    constructor(defaultFilterService) {
        this.defaultFilterService = defaultFilterService;
        this.close = new EventEmitter();
        this.index = 0;
    }
    /**
     * @param {?} _
     * @return {?}
     */
    set visible(_) {
        this.tabs.realignInkBar();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this._filterService = this.filterService || this.defaultFilterService;
    }
    /**
     * @return {?}
     */
    apply() {
        this.filter.start = this.startDate;
        this.filter.end = this.endDate;
        this._filterService.applyFilter(this.filter);
        this.close.next();
    }
    /**
     * @return {?}
     */
    clear() {
        this.startDate = undefined;
        this.endDate = undefined;
        this.apply();
    }
}
DateFilterComponent.ɵfac = function DateFilterComponent_Factory(t) { return new (t || DateFilterComponent)(ɵngcc0.ɵɵdirectiveInject(PwoFilterService)); };
DateFilterComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DateFilterComponent, selectors: [["lib-date-filter"]], viewQuery: function DateFilterComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c3, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.tabs = _t.first);
    } }, inputs: { visible: "visible", filter: "filter", filterService: "filterService" }, outputs: { close: "close" }, decls: 17, vars: 4, consts: [[1, "pwo-filter", "date-filter", 3, "selectedIndex", "selectedIndexChange"], ["tabGroup", ""], ["label", "Start"], [3, "selected", "selectedChange"], ["label", "End"], [3, "selected", "minDate", "selectedChange"], [1, "pwo-filter", "filter-apply"], ["mat-button", "", 3, "click"], [1, "material-icons"]], template: function DateFilterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "mat-tab-group", 0, 1);
        ɵngcc0.ɵɵlistener("selectedIndexChange", function DateFilterComponent_Template_mat_tab_group_selectedIndexChange_0_listener($event) { return ctx.index = $event; });
        ɵngcc0.ɵɵelementStart(2, "mat-tab", 2)(3, "mat-calendar", 3);
        ɵngcc0.ɵɵlistener("selectedChange", function DateFilterComponent_Template_mat_calendar_selectedChange_3_listener($event) { return ctx.startDate = $event; })("selectedChange", function DateFilterComponent_Template_mat_calendar_selectedChange_3_listener() { return ctx.index = 1; });
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(4, "mat-tab", 4)(5, "mat-calendar", 5);
        ɵngcc0.ɵɵlistener("selectedChange", function DateFilterComponent_Template_mat_calendar_selectedChange_5_listener($event) { return ctx.endDate = $event; });
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵelementStart(6, "div", 6)(7, "button", 7);
        ɵngcc0.ɵɵlistener("click", function DateFilterComponent_Template_button_click_7_listener() { return ctx.apply(); });
        ɵngcc0.ɵɵelementStart(8, "i", 8);
        ɵngcc0.ɵɵtext(9, "done");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "span");
        ɵngcc0.ɵɵtext(11, "Apply");
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(12, "button", 7);
        ɵngcc0.ɵɵlistener("click", function DateFilterComponent_Template_button_click_12_listener() { return ctx.clear(); });
        ɵngcc0.ɵɵelementStart(13, "i", 8);
        ɵngcc0.ɵɵtext(14, "clear");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(15, "span");
        ɵngcc0.ɵɵtext(16, "Clear");
        ɵngcc0.ɵɵelementEnd()()();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("selectedIndex", ctx.index);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("selected", ctx.startDate);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("selected", ctx.endDate)("minDate", ctx.startDate);
    } }, dependencies: [ɵngcc3.MatTabGroup, ɵngcc3.MatTab, ɵngcc4.MatCalendar], styles: [".pwo-filter.date-filter[_ngcontent-%COMP%]{min-width:250px}.pwo-filter.filter-apply[_ngcontent-%COMP%]{display:flex}  .pwo-filter .date-filter .mat-tab-label{min-width:0!important;width:50%}"] });
/** @nocollapse */
DateFilterComponent.ctorParameters = () => [
    { type: PwoFilterService }
];
DateFilterComponent.propDecorators = {
    tabs: [{ type: ViewChild, args: ['tabGroup',] }],
    visible: [{ type: Input }],
    filter: [{ type: Input }],
    filterService: [{ type: Input }],
    close: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DateFilterComponent, [{
        type: Component,
        args: [{ selector: 'lib-date-filter', template: "<!-- <mat-form-field>\r\n  <input matInput [matDatepicker]=\"pickerStart\" placeholder=\"Choose a start date\" [(ngModel)]=\"startDate\"\r\n    (dateChange)=\"apply()\">\r\n  <mat-datepicker-toggle matSuffix [for]=\"pickerStart\"></mat-datepicker-toggle>\r\n  <mat-datepicker #pickerStart></mat-datepicker>\r\n</mat-form-field>\r\n\r\n<mat-form-field>\r\n  <input matInput [matDatepicker]=\"pickerEnd\" placeholder=\"Choose an end date\" [(ngModel)]=\"endDate\"\r\n    (dateChange)=\"apply()\">\r\n  <mat-datepicker-toggle matSuffix [for]=\"pickerEnd\"></mat-datepicker-toggle>\r\n  <mat-datepicker #pickerEnd></mat-datepicker>\r\n</mat-form-field> -->\r\n\r\n<mat-tab-group #tabGroup class=\"pwo-filter date-filter\" [(selectedIndex)]=\"index\">\r\n  <mat-tab label=\"Start\">\r\n    <mat-calendar [(selected)]=\"startDate\" (selectedChange)=\"index = 1\"></mat-calendar>\r\n  </mat-tab>\r\n  <mat-tab label=\"End\">\r\n    <mat-calendar [(selected)]=\"endDate\" [minDate]=\"startDate\"></mat-calendar>\r\n  </mat-tab>\r\n</mat-tab-group>\r\n\r\n<div class=\"pwo-filter filter-apply\">\r\n  <button mat-button (click)=\"apply()\">\r\n    <i class=\"material-icons\">done</i>\r\n    <span>Apply</span>\r\n  </button>\r\n  <button mat-button (click)=\"clear()\">\r\n    <i class=\"material-icons\">clear</i>\r\n    <span>Clear</span>\r\n  </button>\r\n</div>", styles: [".pwo-filter.date-filter{min-width:250px}.pwo-filter.filter-apply{display:flex}::ng-deep .pwo-filter .date-filter .mat-tab-label{min-width:0!important;width:50%}"] }]
    }], function () { return [{ type: PwoFilterService }]; }, { close: [{
            type: Output
        }], visible: [{
            type: Input
        }], tabs: [{
            type: ViewChild,
            args: ['tabGroup']
        }], filter: [{
            type: Input
        }], filterService: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MultiSelectFilterComponent {
    /**
     * @param {?} defaultFilterService
     */
    constructor(defaultFilterService) {
        this.defaultFilterService = defaultFilterService;
        this.close = new EventEmitter();
        this.allFilterValues = [];
        this.filterValues = [];
        this.searchTerm = '';
        this.fewSelected = false;
        this.selected = [];
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this._filterService = this.filterService || this.defaultFilterService;
        this.allSelected = this._filterService.matchAllFilters;
        this.init();
    }
    /**
     * @return {?}
     */
    search() {
        /** @type {?} */
        const s = this.searchTerm.toLowerCase();
        this.filterValues = this.allFilterValues.filter(el => str(el.title).toLowerCase().includes(s));
        this.doCheck();
        /**
         * @param {?} s
         * @return {?}
         */
        function str(s) {
            if (!s) {
                return '';
            }
            s = s + '';
            return s.length > 0 ? s : '(Empty)';
        }
    }
    /**
     * @return {?}
     */
    init() {
        this._filterService.filterValuesObservable(this.filter).subscribe(vals => {
            if (!this.filter.isActive() && this._filterService.matchAllFilters) {
                // Filter not set means all values are selected
                vals.forEach(el => el.selected = true);
            }
            this.allFilterValues = vals;
            this.filterValues = vals; // TODO maybe filter for search term again instead of reset it
            this.searchTerm = '';
            this.doCheck();
        });
    }
    /**
     * @return {?}
     */
    select() {
        // Select visible items
        this.filterValues.forEach(f => f.selected = this.allSelected);
        this.doCheck();
    }
    /**
     * @return {?}
     */
    change() {
        this.selected = this.getSelected().map(el => el.title);
        this.doCheck();
    }
    /**
     * @return {?}
     */
    doCheck() {
        /** @type {?} */
        const sel = this.getSelected();
        this.allSelected = this.filterValues.length === sel.length;
        this.fewSelected = sel.length > 0 && sel.length < this.filterValues.length;
        if (this.allFilterValues.length === sel.length && this._filterService.matchAllFilters) {
            // All selected means filter not set
            this.selected = [];
        }
        else {
            this.selected = sel.map(el => el.title);
        }
    }
    /**
     * @return {?}
     */
    getSelected() {
        return this.filterValues.filter(el => el.selected);
    }
    /**
     * @return {?}
     */
    apply() {
        this.filter.selected = this.selected; // .slice() TODO necessary?
        this._filterService.applyFilter(this.filter);
        this.close.next();
    }
}
MultiSelectFilterComponent.ɵfac = function MultiSelectFilterComponent_Factory(t) { return new (t || MultiSelectFilterComponent)(ɵngcc0.ɵɵdirectiveInject(PwoFilterService)); };
MultiSelectFilterComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: MultiSelectFilterComponent, selectors: [["lib-multi-select-filter"]], inputs: { filter: "filter", filterService: "filterService" }, outputs: { close: "close" }, decls: 16, vars: 7, consts: [[1, "pwo-filter", "filter-header"], [1, "input"], ["matInput", "", "autocomplete", "off", "placeholder", "Search for ...", 3, "ngModel", "ngModelChange"], ["mat-button", "", "mat-icon-button", "", "aria-label", "Clear", 3, "click"], [1, "material-icons"], [1, "pwo-filter", "filter-values"], [3, "ngModel", "change", "ngModelChange"], [3, "ngModel", "change", "ngModelChange", 4, "ngFor", "ngForOf"], [1, "pwo-filter", "filter-apply"], ["mat-button", "", 3, "click"]], template: function MultiSelectFilterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "input", 2);
        ɵngcc0.ɵɵlistener("ngModelChange", function MultiSelectFilterComponent_Template_input_ngModelChange_2_listener($event) { return ctx.searchTerm = $event; })("ngModelChange", function MultiSelectFilterComponent_Template_input_ngModelChange_2_listener() { return ctx.search(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "button", 3);
        ɵngcc0.ɵɵlistener("click", function MultiSelectFilterComponent_Template_button_click_3_listener() { ctx.searchTerm = ""; return ctx.search(); });
        ɵngcc0.ɵɵelementStart(4, "i", 4);
        ɵngcc0.ɵɵtext(5, "close");
        ɵngcc0.ɵɵelementEnd()()()();
        ɵngcc0.ɵɵelementStart(6, "div", 5)(7, "mat-checkbox", 6);
        ɵngcc0.ɵɵlistener("change", function MultiSelectFilterComponent_Template_mat_checkbox_change_7_listener() { return ctx.select(); })("ngModelChange", function MultiSelectFilterComponent_Template_mat_checkbox_ngModelChange_7_listener($event) { return ctx.allSelected = $event; });
        ɵngcc0.ɵɵtext(8, " Select all ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(9, MultiSelectFilterComponent_mat_checkbox_9_Template, 2, 2, "mat-checkbox", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "div", 8)(11, "button", 9);
        ɵngcc0.ɵɵlistener("click", function MultiSelectFilterComponent_Template_button_click_11_listener() { return ctx.apply(); });
        ɵngcc0.ɵɵelementStart(12, "i", 4);
        ɵngcc0.ɵɵtext(13, "done");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "span");
        ɵngcc0.ɵɵtext(15, "Apply");
        ɵngcc0.ɵɵelementEnd()()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngModel", ctx.searchTerm);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleProp("visibility", ctx.searchTerm.length ? "visible" : "hidden");
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵclassProp("mat-checkbox-semichecked", ctx.fewSelected);
        ɵngcc0.ɵɵproperty("ngModel", ctx.allSelected);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.filterValues);
    } }, dependencies: [ɵngcc1.NgForOf, ɵngcc5.MatCheckbox, ɵngcc6.DefaultValueAccessor, ɵngcc6.NgControlStatus, ɵngcc6.NgModel, ɵngcc7.MatInput], styles: [".pwo-filter.filter-header .input{display:flex;margin-bottom:8px}.pwo-filter.filter-header .input input{font-size:14px;border:none}.pwo-filter.filter-values{margin:15px 0}.pwo-filter.filter-apply button{display:flex}.pwo-filter.filter-apply button span{margin-left:4px;margin-top:2px}.pwo-filter .mat-checkbox-layout{display:flex!important}.pwo-filter .mat-checkbox-layout .mat-checkbox-label{text-overflow:ellipsis;overflow:hidden;flex:1}.pwo-styles .filter-header .input{border:1px solid #cdd9e1;padding:4px}"], encapsulation: 2 });
/** @nocollapse */
MultiSelectFilterComponent.ctorParameters = () => [
    { type: PwoFilterService }
];
MultiSelectFilterComponent.propDecorators = {
    filter: [{ type: Input }],
    filterService: [{ type: Input }],
    close: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MultiSelectFilterComponent, [{
        type: Component,
        args: [{ selector: 'lib-multi-select-filter', template: "<div class=\"pwo-filter filter-header\">\r\n  <div class=\"input\">\r\n    <input matInput autocomplete=\"off\" placeholder=\"Search for ...\" [(ngModel)]=\"searchTerm\" (ngModelChange)=\"search()\">\r\n    <button mat-button [style.visibility]=\"searchTerm.length ? 'visible' : 'hidden'\" mat-icon-button aria-label=\"Clear\"\r\n      (click)=\"searchTerm = ''; search()\">\r\n      <i class=\"material-icons\">close</i>\r\n    </button>\r\n  </div>\r\n</div>\r\n\r\n<div class=\"pwo-filter filter-values\">\r\n  <mat-checkbox (change)=\"select()\" [(ngModel)]=\"allSelected\" [class.mat-checkbox-semichecked]=\"fewSelected\">\r\n    Select all\r\n  </mat-checkbox>\r\n\r\n  <mat-checkbox *ngFor=\"let f of filterValues\" (change)=\"change()\" [(ngModel)]=\"f.selected\">\r\n    {{ f.title }}\r\n  </mat-checkbox>\r\n</div>\r\n\r\n<div class=\"pwo-filter filter-apply\">\r\n  <button mat-button (click)=\"apply()\">\r\n    <i class=\"material-icons\">done</i>\r\n    <span>Apply</span>\r\n  </button>\r\n</div>\r\n", encapsulation: ViewEncapsulation.None, styles: [".pwo-filter.filter-header .input{display:flex;margin-bottom:8px}.pwo-filter.filter-header .input input{font-size:14px;border:none}.pwo-filter.filter-values{margin:15px 0}.pwo-filter.filter-apply button{display:flex}.pwo-filter.filter-apply button span{margin-left:4px;margin-top:2px}.pwo-filter .mat-checkbox-layout{display:flex!important}.pwo-filter .mat-checkbox-layout .mat-checkbox-label{text-overflow:ellipsis;overflow:hidden;flex:1}.pwo-styles .filter-header .input{border:1px solid #cdd9e1;padding:4px}"] }]
    }], function () { return [{ type: PwoFilterService }]; }, { close: [{
            type: Output
        }], filter: [{
            type: Input
        }], filterService: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SingleSelectFilterComponent {
    /**
     * @param {?} defaultFilterService
     */
    constructor(defaultFilterService) {
        this.defaultFilterService = defaultFilterService;
        this.close = new EventEmitter();
        this.allFilterValues = [];
        this.filterValues = [];
        this.searchTerm = '';
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this._filterService = this.filterService || this.defaultFilterService;
        this.init();
    }
    /**
     * @return {?}
     */
    init() {
        this._filterService.filterValuesObservable(this.filter).subscribe(vals => {
            this.allFilterValues = vals;
            this.search();
            this.selected = vals.find(el => el.selected);
        });
    }
    /**
     * @return {?}
     */
    search() {
        /** @type {?} */
        const s = this.searchTerm.toLowerCase();
        this.filterValues = this.allFilterValues.filter(el => str(el.title).toLowerCase().includes(s));
        if (this.filterValues.length === 1) {
            this.selected = this.filterValues[0];
        }
        /**
         * @param {?} s
         * @return {?}
         */
        function str(s) {
            if (!s) {
                return '';
            }
            s = s + '';
            return s.length > 0 ? s : '(Empty)';
        }
    }
    /**
     * @return {?}
     */
    apply() {
        this.filter.value = this.selected ? this.selected.title : undefined;
        this._filterService.applyFilter(this.filter);
        this.close.next();
    }
    /**
     * @return {?}
     */
    clear() {
        this.selected = undefined;
        this.searchTerm = '';
        this.apply();
    }
}
SingleSelectFilterComponent.ɵfac = function SingleSelectFilterComponent_Factory(t) { return new (t || SingleSelectFilterComponent)(ɵngcc0.ɵɵdirectiveInject(PwoFilterService)); };
SingleSelectFilterComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SingleSelectFilterComponent, selectors: [["lib-single-select-filter"]], inputs: { filter: "filter", filterService: "filterService" }, outputs: { close: "close" }, decls: 14, vars: 5, consts: [[1, "pwo-filter", "filter-header"], [1, "input"], ["matInput", "", "autocomplete", "off", "placeholder", "Search for ...", 3, "ngModel", "ngModelChange", "keyup.enter"], ["mat-button", "", "mat-icon-button", "", "aria-label", "Clear", 3, "click"], [1, "material-icons"], ["class", "pwo-filter filter-values", 4, "ngIf"], [1, "pwo-filter", "filter-apply"], ["mat-button", "", 3, "click"], ["mat-button", "", 3, "click", 4, "ngIf"], [1, "pwo-filter", "filter-values"], [3, "ngModel", "ngModelChange"], [3, "value", 4, "ngFor", "ngForOf"], [3, "value"]], template: function SingleSelectFilterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "input", 2);
        ɵngcc0.ɵɵlistener("ngModelChange", function SingleSelectFilterComponent_Template_input_ngModelChange_2_listener($event) { return ctx.searchTerm = $event; })("ngModelChange", function SingleSelectFilterComponent_Template_input_ngModelChange_2_listener() { return ctx.search(); })("keyup.enter", function SingleSelectFilterComponent_Template_input_keyup_enter_2_listener() { return ctx.selected && ctx.apply(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "button", 3);
        ɵngcc0.ɵɵlistener("click", function SingleSelectFilterComponent_Template_button_click_3_listener() { ctx.searchTerm = ""; return ctx.search(); });
        ɵngcc0.ɵɵelementStart(4, "i", 4);
        ɵngcc0.ɵɵtext(5, "close");
        ɵngcc0.ɵɵelementEnd()()()();
        ɵngcc0.ɵɵtemplate(6, SingleSelectFilterComponent_div_6_Template, 3, 2, "div", 5);
        ɵngcc0.ɵɵelementStart(7, "div", 6)(8, "button", 7);
        ɵngcc0.ɵɵlistener("click", function SingleSelectFilterComponent_Template_button_click_8_listener() { return ctx.apply(); });
        ɵngcc0.ɵɵelementStart(9, "i", 4);
        ɵngcc0.ɵɵtext(10, "done");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "span");
        ɵngcc0.ɵɵtext(12, "Apply");
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵtemplate(13, SingleSelectFilterComponent_button_13_Template, 5, 0, "button", 8);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngModel", ctx.searchTerm);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleProp("visibility", ctx.searchTerm.length ? "visible" : "hidden");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.filterValues);
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵproperty("ngIf", ctx.filter.isApplied);
    } }, dependencies: [ɵngcc1.NgForOf, ɵngcc1.NgIf, ɵngcc8.MatRadioGroup, ɵngcc8.MatRadioButton, ɵngcc6.DefaultValueAccessor, ɵngcc6.NgControlStatus, ɵngcc6.NgModel, ɵngcc7.MatInput], styles: [".pwo-filter.filter-header[_ngcontent-%COMP%]   .input[_ngcontent-%COMP%]{display:flex;margin-bottom:8px}.pwo-filter.filter-header[_ngcontent-%COMP%]   .input[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{font-size:14px}.pwo-filter.filter-values[_ngcontent-%COMP%]   .mat-radio-group[_ngcontent-%COMP%]{display:flex;flex-direction:column;margin:15px 0}.pwo-filter.filter-values[_ngcontent-%COMP%]   .mat-radio-group[_ngcontent-%COMP%]   .mat-radio-button[_ngcontent-%COMP%]{margin:5px;font-size:14px}.pwo-filter.filter-apply[_ngcontent-%COMP%], .pwo-filter.filter-apply[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{display:flex}.pwo-filter.filter-apply[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{margin-left:4px;margin-top:2px}.pwo-styles[_ngcontent-%COMP%]   .filter-header[_ngcontent-%COMP%]   .input[_ngcontent-%COMP%]{border:1px solid #cdd9e1;padding:4px}  .pwo-filter .mat-radio-button .mat-radio-label{max-width:100%}  .pwo-filter .mat-radio-button .mat-radio-label .mat-radio-label-content{text-overflow:ellipsis;overflow-x:hidden}"] });
/** @nocollapse */
SingleSelectFilterComponent.ctorParameters = () => [
    { type: PwoFilterService }
];
SingleSelectFilterComponent.propDecorators = {
    filter: [{ type: Input }],
    filterService: [{ type: Input }],
    close: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SingleSelectFilterComponent, [{
        type: Component,
        args: [{ selector: 'lib-single-select-filter', template: "<div class=\"pwo-filter filter-header\">\r\n  <div class=\"input\">\r\n    <input matInput autocomplete=\"off\" placeholder=\"Search for ...\" [(ngModel)]=\"searchTerm\" (ngModelChange)=\"search()\" (keyup.enter)=\"selected && apply()\">\r\n    <button mat-button [style.visibility]=\"searchTerm.length ? 'visible' : 'hidden'\" mat-icon-button aria-label=\"Clear\"\r\n      (click)=\"searchTerm = ''; search()\">\r\n      <i class=\"material-icons\">close</i>\r\n    </button>\r\n  </div>\r\n</div>\r\n\r\n<div *ngIf=\"filterValues\" class=\"pwo-filter filter-values\">\r\n  <mat-radio-group [(ngModel)]=\"selected\">\r\n    <mat-radio-button *ngFor=\"let f of filterValues\" [value]=\"f\">\r\n      {{ f.title }}\r\n    </mat-radio-button>\r\n  </mat-radio-group>\r\n</div>\r\n\r\n<div class=\"pwo-filter filter-apply\">\r\n  <button mat-button (click)=\"apply()\">\r\n    <i class=\"material-icons\">done</i>\r\n    <span>Apply</span>\r\n  </button>\r\n  <button *ngIf=\"filter.isApplied\" mat-button (click)=\"clear()\">\r\n    <i class=\"material-icons\">clear</i>\r\n    <span>Clear</span>\r\n  </button>\r\n</div>\r\n", styles: [".pwo-filter.filter-header .input{display:flex;margin-bottom:8px}.pwo-filter.filter-header .input input{font-size:14px}.pwo-filter.filter-values .mat-radio-group{display:flex;flex-direction:column;margin:15px 0}.pwo-filter.filter-values .mat-radio-group .mat-radio-button{margin:5px;font-size:14px}.pwo-filter.filter-apply,.pwo-filter.filter-apply button{display:flex}.pwo-filter.filter-apply button span{margin-left:4px;margin-top:2px}.pwo-styles .filter-header .input{border:1px solid #cdd9e1;padding:4px}::ng-deep .pwo-filter .mat-radio-button .mat-radio-label{max-width:100%}::ng-deep .pwo-filter .mat-radio-button .mat-radio-label .mat-radio-label-content{text-overflow:ellipsis;overflow-x:hidden}"] }]
    }], function () { return [{ type: PwoFilterService }]; }, { close: [{
            type: Output
        }], filter: [{
            type: Input
        }], filterService: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class RangeFilterComponent {
    constructor() { }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
}
RangeFilterComponent.ɵfac = function RangeFilterComponent_Factory(t) { return new (t || RangeFilterComponent)(); };
RangeFilterComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: RangeFilterComponent, selectors: [["lib-range-filter"]], decls: 2, vars: 0, template: function RangeFilterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "p");
        ɵngcc0.ɵɵtext(1, " range-filter works!\n");
        ɵngcc0.ɵɵelementEnd();
    } } });
/** @nocollapse */
RangeFilterComponent.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RangeFilterComponent, [{
        type: Component,
        args: [{ selector: 'lib-range-filter', template: "<p>\r\n  range-filter works!\r\n</p>\r\n" }]
    }], function () { return []; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PwoFilterAnchorDirective extends MatMenuTrigger {
    /**
     * @return {?}
     */
    ngOnInit() {
        if (!this.filterComponent) {
            throw new Error('pwoFilterAnchor must have PwoFilterComponent (<pwo-filter>) as a child!');
        }
        this.filterComponent.isAnchored = true;
        this.menu = this.filterComponent.menuRef;
        this.filterComponent.toggle.subscribe((state) => {
            if (this.menuOpen !== state) {
                if (state) {
                    this.openMenu();
                }
                else {
                    this.closeMenu();
                }
            }
        });
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.filterComponent.toggle.unsubscribe();
    }
}
PwoFilterAnchorDirective.ɵfac = /*@__PURE__*/ function () { let ɵPwoFilterAnchorDirective_BaseFactory; return function PwoFilterAnchorDirective_Factory(t) { return (ɵPwoFilterAnchorDirective_BaseFactory || (ɵPwoFilterAnchorDirective_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(PwoFilterAnchorDirective)))(t || PwoFilterAnchorDirective); }; }();
PwoFilterAnchorDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: PwoFilterAnchorDirective, selectors: [["", "pwoFilterAnchor", ""]], contentQueries: function PwoFilterAnchorDirective_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, PwoFilterComponent, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.filterComponent = _t.first);
    } }, exportAs: ["matMenuTrigger"], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
PwoFilterAnchorDirective.propDecorators = {
    filterComponent: [{ type: ContentChild, args: [PwoFilterComponent,] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PwoFilterAnchorDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line: directive-selector
                selector: '[pwoFilterAnchor]',
                // host: {
                //   'aria-haspopup': 'true',
                //   '[attr.aria-expanded]': 'menuOpen || null',
                //   '(mousedown)': '_handleMousedown($event)',
                //   '(keydown)': '_handleKeydown($event)',
                //   '(click)': '_handleClick($event)',
                // },
                exportAs: 'matMenuTrigger'
            }]
    }], null, { filterComponent: [{
            type: ContentChild,
            args: [PwoFilterComponent]
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PwoFilterModule {
}
PwoFilterModule.ɵfac = function PwoFilterModule_Factory(t) { return new (t || PwoFilterModule)(); };
PwoFilterModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: PwoFilterModule });
PwoFilterModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule,
        MatMenuModule,
        MatCheckboxModule,
        MatRadioModule,
        FormsModule,
        MatButtonToggleModule,
        MatFormFieldModule,
        MatSelectModule,
        MatInputModule,
        ReactiveFormsModule,
        MatTableModule,
        MatChipsModule,
        MatDialogModule,
        MatProgressSpinnerModule,
        MatTabsModule,
        MatDatepickerModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PwoFilterModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    MatMenuModule,
                    MatCheckboxModule,
                    MatRadioModule,
                    FormsModule,
                    MatButtonToggleModule,
                    MatFormFieldModule,
                    MatSelectModule,
                    MatInputModule,
                    ReactiveFormsModule,
                    MatTableModule,
                    MatChipsModule,
                    MatDialogModule,
                    MatProgressSpinnerModule,
                    MatTabsModule,
                    MatDatepickerModule,
                ],
                exports: [
                    PwoFilterComponent,
                    PwoFilterAnchorDirective
                ],
                declarations: [
                    PwoFilterComponent,
                    DateFilterComponent,
                    MultiSelectFilterComponent,
                    SingleSelectFilterComponent,
                    RangeFilterComponent,
                    PwoFilterAnchorDirective
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(PwoFilterModule, { declarations: function () { return [PwoFilterComponent, DateFilterComponent, MultiSelectFilterComponent, SingleSelectFilterComponent, RangeFilterComponent, PwoFilterAnchorDirective]; }, imports: function () { return [CommonModule,
        MatMenuModule,
        MatCheckboxModule,
        MatRadioModule,
        FormsModule,
        MatButtonToggleModule,
        MatFormFieldModule,
        MatSelectModule,
        MatInputModule,
        ReactiveFormsModule,
        MatTableModule,
        MatChipsModule,
        MatDialogModule,
        MatProgressSpinnerModule,
        MatTabsModule,
        MatDatepickerModule]; }, exports: function () { return [PwoFilterComponent, PwoFilterAnchorDirective]; } }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { PwoFilterService, PwoFilterModule, isFilterValueGenerator, Filter, ValueFilter, MultiValueFilter, RangeFilter, DateFilter, PwoFilterComponent, FilterDataSource, PwoFilterAnchorDirective as ɵa, DateFilterComponent as ɵb, MultiSelectFilterComponent as ɵc, RangeFilterComponent as ɵe, SingleSelectFilterComponent as ɵd };


